import ImpactsOnStakeholderFooter from './ImpactsOnStakeholderFooter';

export default ImpactsOnStakeholderFooter;
